
import { React, useState } from "react";
import { Grid, Box, Tabs, Tab } from "@mui/material";
import { useLocation } from "react-router-dom";
import { JobDetailsList } from "./Accordianlist"
import JobCategory from "./JobCategory";
import JobDetails from "./JobDetails";
import JobUpdate from "./JobUpdate";
import AddressDetails from "./AddressDetails";
import "./styles.css";
import QuoteDetails from "./QuoteDetails";

const TabPanel = (props) => {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 0 }}>
          <div>{children}</div>
        </Box>
      )}
    </div>
  );
}
function a11yProps(index, tabName) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": tabName,
  };
}
const Profile = (props) => {
  const [value, setValue] = useState(0);
  const location = useLocation();
  const locStateVal = location?.state;
  const disableQuoteTab = locStateVal?.disableQuoteTab;

  const handleChange = (event, tabVal) => {
    setValue(tabVal);
  };
  return (
    <Grid style={{}}>
      <Box
        sx={{
          borderBottom: 1,
          borderColor: "divider",
          margin: "0% 6%",
        }}
      >
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="basic tabs example"
          variant="fullWidth"
        >
          <Tab label="Job Details" {...a11yProps(0)} />
          <Tab
            label="Quote Details"
            disabled={disableQuoteTab}
            {...a11yProps(1)}
          />
        </Tabs>
      </Box>
      <TabPanel value={value} index={0}>
        {JobDetailsList?.map((item, JobList) => {
          return <JobCategory item={item} />

        })}
        <JobDetails />
        <AddressDetails />
        <JobUpdate />
      </TabPanel>
      <TabPanel value={value} index={1}>
      
         <QuoteDetails handleSetActive={props.handleSetActive}/>

      </TabPanel>
    </Grid>
  );
};

export default Profile;